/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        button: {
            color: 'black'
        },
        container: {},
        text: {
            fontFamily: 'Raleway',
            fontWeight: '300',
            fontSize: ['14px', '14px', '20px', '20px'],
            whiteSpace: 'nowrap',
            paddingLeft: ['10px', '10px', '14px', '14px'],
            paddingRight: ['10px', '10px', '14px', '14px']
        },
        preNextText: {
            fontFamily: 'Raleway',
            fontWeight: '300',
            fontSize: ['14px', '14px', '20px', '20px'],
            whiteSpace: 'nowrap'
        }
    },
    parts: ['button', 'container', 'text']
}
